import {Button, Center, useTheme} from 'native-base';
import IcPlus from '@ui/svg/IcPlus';
import React from 'react';
import {useTranslation} from 'react-i18next';

interface Props {
    onPress: () => void;
}

const CreateTeamButton = (props: Props) => {
    const {t} = useTranslation();

    return (
        <Center h='12' bg='white' my='4'>
            <Button
                variant='ghostOutline'
                flex={1}
                w='full'
                onPress={props.onPress}
                leftIcon={<IcPlus />}
            >
                {t('team.select.create')}
            </Button>
        </Center>
    );
};

export const CreateTeamButtonSmall = (props: Props) => {
    const {t} = useTranslation();
    const theme = useTheme();

    return (
        <Button
            variant='ghostOutline'
            _text={{color: 'black'}}
            py={3}
            flex={1}
            w='full'
            onPress={props.onPress}
            leftIcon={<IcPlus fill={theme.colors.black} />}
        >
            {t('team.select.create')}
        </Button>
    );
};

export default CreateTeamButton;
